import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';

@Injectable({
  providedIn: 'root'
})
export class UnitPriceService {
  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  getUnitPrice(): Observable<any> {
    let userID = localStorage.getItem('mcmt_userId');
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'GET',
      url: this.ROOT_URL + "/api/UnitPrice/GetUnitPrice?userID=" + userID,
      headers: headers
    })

    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });

  }

  downloadExcel(): Observable<any> {
    let userID = localStorage.getItem('mcmt_userId');

    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'GET',
      url: this.ROOT_URL + "/api/UnitPrice/DownloadUnitPriceExcel?userID=" + userID,
      headers: headers,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        var blob = new Blob([res.blob()], { type: 'xlsx' })
        return blob;
      });

  }

  uploadUnitPrice(documents: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", documents);
    formData.append("UserId", localStorage.getItem('mcmt_userId'));

    let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      headers: headers
    })
    return this.http.post(this.ROOT_URL + "/api/UnitPrice/UploadUnitPrice", formData, requestoptions)
      .map((res: Response) => {
        return res.json();
      });
  }
}
